import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import { ability } from './ability'
import { AbilityContext } from './ability/context'
import App from './components/app2'
import { SidebarProvider } from './components/layout/context'
import { queryClient } from './lib/query-client'
import { setup } from './lib/setup'
import { store } from './store'

import './styles/main.scss'
import type { AppAbility } from './ability/types'

let container = document.getElementById('app')

if (!container) {
  throw new Error('Container #app not found')
}

let root = createRoot(container)

setup()
  .then(() => {
    root.render(
      <StrictMode>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <SidebarProvider>
              <AbilityContext.Provider value={ability as AppAbility}>
                <App />
              </AbilityContext.Provider>
            </SidebarProvider>
          </QueryClientProvider>
        </Provider>
      </StrictMode>
    )
  })
  .catch(err => {
    console.error(err)
  })
